import { render, staticRenderFns } from "./appLogosPlatform.vue?vue&type=template&id=02e18560&scoped=true"
import script from "./appLogosPlatform.vue?vue&type=script&lang=js"
export * from "./appLogosPlatform.vue?vue&type=script&lang=js"
import style0 from "./appLogosPlatform.vue?vue&type=style&index=0&id=02e18560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e18560",
  null
  
)

export default component.exports